<template lang="pug">
.hotCircle(:style="`width:${pxToRem(w)};height:${pxToRem(h)};left:${pxToRem(l-w*.5)};top:${pxToRem(t-h*.5)};backgroundColor:${color}1`")
    .hotCircle1(:class="cursor?'showHand':'hideHand'" @click="onfunc" :style="`backgroundColor:${color}5`")
        .hotCircle2.pulseForever1(:style="`backgroundColor:${color}f`")
        .hotCircle2(:style="`backgroundColor:${color}f`")


</template>
<script>
import basefunc from './basefunc'
// Breath(l=851 t=323 :color="`#ff0`" v-show="curname==='P17'")

export default {
    props:{
        func: {default: null},
        cursor: {default: true},
        w: {default: 100},
        h: {default: 100},
        l: {default: 0},
        t: {default: 0},
        color: {default: '#fff'},
    },
    data(){
        return{
            //configLoaded: false,
            //assets: null
        }
    },
    mixins:[basefunc],

    mounted(){

    },
    methods:{
        onfunc(){console.log('fffffffffffff')
            if(this.func)this.func()
        }
    }

}
</script>

<style lang="sass" scoped>
@import '@/styles/common'
@import '@/styles/myani'
$c1: #fff1
$c2: #fff5
$c3: #fff
// $c1: #0cf1
// $c2: #0cf5
// $c3: #0cf
.hotCircle
    background: $c1
    position: absolute
    border-radius: 50%
    display: flex
    justify-content: center
    align-items: center
    .hotCircle1
        background: $c2
        width: 70%
        height: 70%
        position: absolute
        border-radius: 50%
        display: flex
        justify-content: center
        align-items: center
        .hotCircle2
            position: absolute
            background: $c3
            width: 40%
            height: 40%
            border-radius: 50%
            pointer-events: none

    .showHand
        cursor: pointer
        pointer-events: all
    .hideHand
        cursor: none
        pointer-events: none

</style>